<template>
  <div v-show="isShow">
    <div><img @click="returnPage()" class="return-btn" src="../../assets/return-page.png" height="36" width="20"/></div>
    <div class="pro-head">内容详情</div>
    <div class="item-title">{{ newsInfo.title }}</div>
    <div class="item-time">{{ newsInfo.addTime }}</div>
    <div class="item-content" v-html="newsInfo.content"></div>
    <div style="margin-bottom: 30px"></div>
  </div>
</template>

<script>
export default {
  name: "newsDetails",
  data(){
    return{
      isShow:false,
      newsInfo:{},
    }
  },
  mounted() {
    window.scroll(0, 0);
  },
  methods:{
    init(row){
      this.isShow = true
      this.axios({
        url: 'https://www.gocheck.cn/newsAction/getNewsInfo.do',//请求地址
        method:'post',//请求方法
        responseType: 'json',//返回值类型
        async: false,
        params: {
          id: row.ID,
        }
      }).then(res => {
        console.log(res)//请求成功
        const date = new Date(res.data.newsInfo.addTime); // 创建一个日期对象
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const formattedDate = year+'-'+month+'-'+day
        res.data.newsInfo.addTime = formattedDate
        this.newsInfo = res.data.newsInfo
      }).catch(error => {
        console.log(error);//请求失败
      })
    },
    returnPage(){
      this.isShow = false
      this.$emit('returnPage')
    },
  }
}
</script>

<style scoped>
.item-title{
    font-size: 20px;
    font-weight: bold;
    margin-top: 30px;
    text-align: left;
    padding: 10px;
}
.item-time{
    color: #999999;
    font-size: 14px;
    text-align: right;
    padding: 10px 18px;
}
.item-content{
    font-size: 16px;
    text-align: left;
    margin: 20px;
    margin-bottom: 100px;
}
.pro-head{
    position: fixed;
    height: 64px;
    background: #005CE5;
    margin: auto;
    left: 0;
    top: 0;
    right: 0;
    color: #FFFFFF;
    font-size: 18px;
    line-height: 65px;
    z-index: 9999;
}
.return-btn{
    position: fixed;
    z-index: 99999;
    margin: auto;
    top: 22px;
    left: 12px;
    width: 10px;
    height: 18px;
}
</style>